import api from '@/api';

import { PageResult } from '@/core/request/PageResult';

import {
  FavoritesHelpItemQuery,
  HelpItem,
  HelpItemFavorite,
} from './HelpItems.types';

import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/HelpItems`;

export async function listLastHelpItems(): Promise<PageResult<HelpItem>> {
  return api.get(
    `${CONTROLLER_URL}/last`,
    null,
  ) as unknown as PageResult<HelpItem>;
}

export async function searchHelpItems(
  search?: string,
): Promise<PageResult<HelpItem>> {
  return api.get(`${CONTROLLER_URL}/Search`, {
    search,
  }) as unknown as PageResult<HelpItem>;
}

export async function getHelpItem(id: number): Promise<HelpItem> {
  return api.get(`${CONTROLLER_URL}/${id}`, null) as unknown as HelpItem;
}

export async function getFavoritesHelpItem(params?: FavoritesHelpItemQuery) {
  return api.get(
    `${CONTROLLER_URL}/favorites`,
    params,
  ) as unknown as PageResult<HelpItemFavorite>;
}

export async function favoriteHelpItem(id: number) {
  return (await api.patch(
    `${CONTROLLER_URL}/${id}/favorites`,
    {},
    null,
  )) as unknown;
}

export async function unfavoriteHelpItem(id: number) {
  return (await api.patch(
    `${CONTROLLER_URL}/${id}/unfavorites`,
    {},
    null,
  )) as unknown;
}
